export default "__VITE_ASSET__BvW_zpJ6__"